import React from "react";
import NewOrganizationContent from "../components/organizations/new-organization-content";

const NewOrganization = () => {
  return <NewOrganizationContent />;
};

export default NewOrganization;
